export default "__VITE_PUBLIC_ASSET__ea36790d__"